import { render } from "./SelectJoin.vue?vue&type=template&id=501972b8"
import script from "./SelectJoin.vue?vue&type=script&lang=js"
export * from "./SelectJoin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__